import {createAction, props} from "@ngrx/store";
import {Research} from "../../models/Research";

export const UPDATE = '[Researches] Update';
export const REFRESH = '[Researches] Refresh';
export const update = createAction(UPDATE, props<{ researches: Research[] }>());
export const refresh = createAction(REFRESH);
